import { useTranslation } from "react-i18next";
import CustomTable from "components/ReactTable/CustomTable";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "reactstrap";
import { ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import TableFilter from "components/TableFilter/TableFilter";
import { GetUnapprovedDataSet } from "network/wineDataSetAPI";
import PATHS from "constant/paths";
import { ReadNotificationAPI } from "network/wineDataSetAPI";
import { UserContextProvider } from "context/UserContext";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { successToaster } from "components/common/toast";
import { DeleteWineDataRequest } from "network/wineDataSetAPI";
import { GetAdminNotifications } from "network/wineDataSetAPI";

const UnapprovedWineDataTable = () => {
  const { t } = useTranslation("wine");
  const navigate = useNavigate();
  const [dataSet, setDataSet] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState([]);
  const [filter, setFilter] = useState([]);
  const [total, setTotal] = useState(null);
  const [fetchTrigger, setFetchTrigger] = useState(false);
  const [alert, setAlert] = useState(null);

  const { setNotifications, notifications } = useContext(UserContextProvider);

  const GetNotificationList = async () => {
    try {
      const response = await GetAdminNotifications();
      if (response.success) {
        setNotifications({
          items: response?.notifications?.items || [],
          count: response?.notifications?.notification_count || 0,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ReadNotification = async (id) => {
    try {
      const response = await ReadNotificationAPI(id);
      if (response.success) {
        // setNotifications((prev) => ({
        //   ...prev,
        //   items: prev.items.filter(
        //     (item) => item.wine_dataset_request_uuid !== id
        //   ),
        //   count: Math.max(prev.count - 1, 0),
        // }));
        GetNotificationList();
        navigate(`${PATHS.WINE_DATASET_UNAPPROVED_VIEW}/${id}`);
      }
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
    }
  };

  const pageSize = 10;

const REQUEST_FILTERS = [
  { value: "", label: t("requests.filterAll") },
  { value: "new", label: t("requests.filterNew") },
  { value: "read", label: t("requests.filterRead") },
  { value: "no_ean", label: t("requests.filterNoEan") },
  { value: "no_vintage", label: t("requests.filterNoVintage") },
];

  const columns = useMemo(
    () => [
      {
        Header: t("requests.colRestaurant"),
        // Nome della persona (come nella lista utenti); se manca, il nome del ristorante.
        accessor: (row) => row.requested_by_name || row.restaurant_name,
        Cell: ({ value, row }) => (
          <div>
            <div>{value || "-"}</div>
            {row?.original?.requested_by ? (
              <small className="text-muted">{row.original.requested_by}</small>
            ) : null}
          </div>
        ),
      },
      {
        Header: t("requests.colRequestedAt"),
        accessor: (row) => row.requested_at,
        Cell: ({ value }) =>
          value
            ? new Date(value).toLocaleString("it-IT", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "-",
      },
      {
        Header: t("fields.ean"),
        accessor: (row) => row.ean,
        Cell: ({ value }) => value || "-",
      },
      {
        Header: t("requests.colWineName"),
        accessor: (row) => row.name,
        Cell: ({ value, row }) => (
          <span>
            {value || "-"}{" "}
            {row?.original?.is_new ? (
              <span className="badge badge-danger ml-2">{t("requests.badgeNew")}</span>
            ) : null}
          </span>
        ),
      },
      {
        Header: t("requests.colCategory"),
        accessor: "categories",
        Cell: ({ value }) =>
          value && value.length
            ? `${value
                .slice(0, 3)
                .map((item) => item.name)
                .join(" , ")}${value.length > 3 ? " ..." : ""}`
            : "-",
      },

      {
        Header: t("requests.colSubCategory"),

        accessor: "sub_categories",
        Cell: ({ value }) =>
          value && value.length
            ? `${value
                .slice(0, 3)
                .map((item) => item.name)
                .join(" , ")}${value.length > 3 ? " ..." : ""}`
            : "-",
      },

      // {
      //   Header: "dateset",
      //   accessor: "has_wine_data",
      //   Cell: ({ value }) => (value ? "True" : "False"),
      // },

      {
        Header: t("common.actions"),
        accessor: "Action",
        Cell: ({ row }) => (
          <div className="d-flex  align-items-center">
            <i
              className="mr-3 pointer"
              onClick={() =>
                ReadNotification(row?.original?.wine_dataset_request_uuid)
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={20}
                height={20}
                className="eyeIcon"
              >
                <path d="M288 144a110.9 110.9 0 0 0 -31.2 5 55.4 55.4 0 0 1 7.2 27 56 56 0 0 1 -56 56 55.4 55.4 0 0 1 -27-7.2A111.7 111.7 0 1 0 288 144zm284.5 97.4C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 400c-98.7 0-189.1-55-237.9-144C98.9 167 189.3 112 288 112s189.1 55 237.9 144C477.1 345 386.7 400 288 400z" />
              </svg>
            </i>
            <i
              className="tim-icons icon-trash-simple text-danger pointer"
              onClick={() =>
                warningWithConfirmMessage(
                  row?.original?.wine_dataset_request_uuid
                )
              }
            ></i>
          </div>
        ),
      },
    ],
    [t]
  );
  const warningWithConfirmMessage = (id) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("common.confirmTitle")}
        onConfirm={() => successDelete(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("common.confirmYes")}
        cancelBtnText={t("common.cancel")}
        showCancel
        btnSize=""
      >
        {t("requests.confirmDelete")}
      </ReactBSAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };
  const successDelete = async (id) => {
    try {
      const response = await DeleteWineDataRequest(id);

      if (response.success) {
        successToaster(t("requests.deleted"));
        setDataSet((prevUsers) =>
          prevUsers.filter((values) => values?.wine_dataset_request_uuid !== id)
        );
        // setNotifications((prev) => ({
        //   ...prev,
        //   items: prev.items.filter(
        //     (item) => item.wine_dataset_request_uuid !== id
        //   ),
        //   count: Math.max(prev.count - 1, 0),
        // }));
        GetNotificationList();

        hideAlert();
      } else {
        hideAlert();
        ErrorToaster(t("requests.deleteFailed"));
      }
    } catch (error) {
      hideAlert();
      ErrorToaster(t("requests.deleteFailed"));
    }
  };
  async function getData() {
    try {
      setIsLoading(true);
      const response = await GetUnapprovedDataSet(
        currentPage,
        pageSize,
        search,
        sort?.value,
        filter?.value
      );
      if (response.success) {
        setIsLoading(false);
        setDataSet(response?.data?.products);
        setTotalPages(response?.data?.total_pages);
        setTotal(response?.data?.total_count);
      }
    } catch (errors) {
      // non lasciare le righe della pagina precedente: sembrerebbero quelle di questa
      setIsLoading(false);
      setDataSet([]);
      ErrorToaster(handleError(errors?.status_code, errors?.message));
    }
  }
  useEffect(() => {
    setCurrentPage(1);
    setFetchTrigger((prev) => !prev);
  }, [sort, search, filter]);

  useEffect(() => {
    getData();
  }, [currentPage, fetchTrigger, notifications.count]);
  return (
    <div className="content my-4">
      {alert}
      <Card className="p-4">
        <div className=" d-flex flex-wrap justify-content-between align-items-center  mb-2">
          <h2 className="card-title text-capitalize">
            {t("requests.title")}
          </h2>
        </div>

        <TableFilter
          setSearch={setSearch}
          search={search}
          showSearch
          showSort
          setSort={setSort}
          sort={sort}
          showFilter
          filter={filter}
          setFilter={setFilter}
          filterOptionsList={REQUEST_FILTERS}
          total={total}
          totalLabel={t("requests.totalLabel")}
        />
        <CustomTable
          data={dataSet}
          columns={columns}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          showPagination={totalPages > 1}
          isLoading={isLoading}
        />
      </Card>
    </div>
  );
};

export default UnapprovedWineDataTable;
